import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/ai-counselor/page.tsx");
